import React, { Component } from "react";
import { Container } from "react-bootstrap";

class ZoomInfo extends Component {
  state = {
    m_09_14_20: [
      [
        "Voter Intimidation: 9am-10am",
        "https://zoom.us/j/93411427682?pwd=WG1HUW90MVRUcWNvNGlkU2R5SWFCZz09",
      ],
      [
        "Equipment Troubleshooting: 11am-12pm",
        "https://zoom.us/j/98245556456?pwd=MWlKNm5yNDhwQ0RXY3o5eEZBNFI1QT09",
      ],
      [
        "COVID-19 and Daily Tasks: 1pm-2pm",
        "https://zoom.us/j/98375554260?pwd=cGozN3F4cXhLalpONEd4SmRjNVlFdz09",
      ],
      [
        "Forms: 3pm-4pm",
        "https://zoom.us/j/96500746800?pwd=Z1VRS2xKWmJwMXprZHZLejRyNS9wQT09",
      ],
    ],
    tu_09_15_20: [
      [
        "Election Night Routine: 9am-10am",
        "https://zoom.us/j/99170284970?pwd=YlZzN2ZaaUFlL1I5bmFsL1Vrc0VUdz09",
      ],
      [
        "Best Practices: 11am-12pm",
        "https://zoom.us/j/96545612928?pwd=WW1OZnpGaGRjaDgrWmVZcW1mdEZFUT09",
      ],
      [
        "Voter Intimidation: 1pm-2pm",
        "https://zoom.us/j/96136523867?pwd=bUNOditjNG1UbjFzSS9rU3pLcXU3dz09",
      ],
      [
        "Equipment Troubleshooting: 3pm-4pm",
        "https://zoom.us/j/99489431474?pwd=Z01lMmh6dHArTjhCSXg0K0J5OFVIQT09",
      ],
    ],
    w_09_16_20: [
      [
        "Closing Routine: 9am-10am",
        "https://zoom.us/j/99487664835?pwd=d1BlcE9jRXgybTl6VkdXc1NDMkNvUT09",
      ],
      [
        "Election Night Routine: 11am-12pm",
        "https://zoom.us/j/99386540178?pwd=ekNYbWt1cjFoNHJ3SjFzQ3ozYXoyQT09",
      ],
      [
        "Best Practices: 1pm-2pm",
        "https://zoom.us/j/92369140383?pwd=eTBaZDJEWlNHOU9WMHpTTThpblVBQT09",
      ],
      [
        "Voter Intimidation: 3pm-4pm",
        "https://zoom.us/j/93350437819?pwd=UEsvYVRYM20remZrWEtDczdlajZXZz09",
      ],
    ],
    th_09_17_20: [
      [
        "Opening Routine: 9am-10am",
        "https://zoom.us/j/98585644262?pwd=S0M0dlhvUlV3RGptclVnTDNCSWVUZz09",
      ],
      [
        "Closing Routine: 11am-12pm",
        "https://zoom.us/j/92989553252?pwd=Uml2c1dnWkZCdW1KWGxaN093TlIzUT09",
      ],
      [
        "Election Night: 1pm-2pm",
        "https://zoom.us/j/98572797638?pwd=LzdISlk5MXFYeng3KzhNKzdOaXJIdz09",
      ],
      [
        "Best Practices: 3pm-4pm",
        "https://zoom.us/j/94999068152?pwd=T3k5dkh0UkRpZVpQeCtoTzZWbnJpQT09",
      ],
    ],
    sat_09_19_20: [
      [
        "Conditional Voter Registration and Provisional Ballots: 9am-10am",
        "https://zoom.us/j/97837649061?pwd=YlRpRTdwcTZSdUt4M1hwOE1CY0JxQT09",
      ],
      [
        "Voter Assistance: 11am-12pm",
        "https://zoom.us/j/95061370186?pwd=WXNXSkRGdTlCd0pwcEx5RVAwVTJPdz09",
      ],
      [
        "Opening Routine: 1pm-2pm",
        "https://zoom.us/j/91321860714?pwd=Q1UxWWROdTRtbDZUK0NIaUhhWDZOZz09",
      ],
      [
        "Closing Routine: 3pm-4pm",
        "https://zoom.us/j/91350127836?pwd=TmFZRzk4aGMvSHU0ZnRYZzV0am5GQT09",
      ],
    ],
    m_09_21_20: [
      [
        "Processing Voters: 9am-10am",
        "https://zoom.us/j/95841252150?pwd=SUJXMWZxRXh5SVVMOUFsM2tPYXNnZz09",
      ],
      [
        "Conditional Voter Registration and Provisional Ballots: 11am-12pm",
        "https://zoom.us/j/97958352776?pwd=MVFSVjVhenhzTmdUU2NjL1NnaDVaZz09",
      ],
      [
        "Voter Assistance: 1pm-2pm",
        "https://zoom.us/j/99626489829?pwd=dDExMHk2NjBpSTFRNm53a05XM2FiZz09",
      ],
      [
        "Opening Routine: 3pm-4pm",
        "https://zoom.us/j/97359994268?pwd=cDdjODJMQmRQd0RxZGIvcStSK0llZz09",
      ],
    ],
    tu_09_22_20: [
      [
        "COVID-19 and Daily Tasks: 9am-10am",
        "https://zoom.us/j/91707522494?pwd=YU9CQVZQSVA4Tk4vcXVCaHBCR3B4QT09",
      ],
      [
        "Forms: 11am-12pm",
        "https://zoom.us/j/97459275221?pwd=QXdLUHZNOC9hLzZHbW5QeTRJUEFQZz09",
      ],
      [
        "Processing Voters: 1pm-2pm",
        "https://zoom.us/j/98207286720?pwd=dlJJMkU1SUtkaXE5RDVwU0ZOTWVmdz09",
      ],
      [
        "Conditional Voter Registration and Provisional Ballots: 3pm-4pm",
        "https://zoom.us/j/99779360540?pwd=YS9venBkSllmb25iYmVvTGlsSHcwUT09",
      ],
    ],
    w_09_23_20: [
      [
        "Equipment Troubleshooting: 9am-10am",
        "https://zoom.us/j/93361824343?pwd=OHc4UHFRNkZJVzNwd1dkb2h2QklVdz09",
      ],
      [
        "COVID-19: 11am-12pm",
        "https://zoom.us/j/98860485690?pwd=bFUwR1hjWU1LK3IxUHFFbFZvMmdjZz09",
      ],
      [
        "Forms: 1pm-2pm",
        "https://zoom.us/j/96714052170?pwd=elRxQUhIbHE3TkJua2ZOMUtXZWV6dz09",
      ],
      [
        "Processing Voters: 3pm-4pm",
        "https://zoom.us/j/95004642351?pwd=RE9wNkpBeFQ5M2NQVTBTb1psZ0YxQT09",
      ],
    ],
    th_09_24_20: [
      [
        "Voter Intimidation: 9am-10am",
        "https://zoom.us/j/99531257195?pwd=WGhTbzV0b1hLN3hUWjdEZHhyOW5MZz09",
      ],
      [
        "Equipment Troubleshooting: 11am-12pm",
        "https://zoom.us/j/97524411805?pwd=Z2d6b1d3VnJYNmxWdkl3MklWMUw5Zz09",
      ],
      [
        "COVID-19: 1pm-2pm",
        "https://zoom.us/j/97085901051?pwd=ZzZqK2xVTkczR3Jhd2lxMEdERTJyZz09",
      ],
      [
        "Forms: 3pm-4pm",
        "https://zoom.us/j/93088066736?pwd=bitwM0lNNVV0djZXdEhvQkE2ZmRrQT09",
      ],
    ],
    f_09_25_20: [
      [
        "Best Practices: 9am-10am",
        "https://zoom.us/j/95115812598?pwd=TUNobHphRE90UlhHdnBBMjIvc3Btdz09",
      ],
      [
        "Voter Intimidation: 11am-12pm",
        "https://zoom.us/j/97383692113?pwd=SDBCMS9URjFuWDJUMUE1Y3lGYWNrQT09",
      ],
      [
        "Equipment Troubleshooting: 1pm-2pm",
        "https://zoom.us/j/91573779022?pwd=anVpcjBKcVBkZlVrZU9RRDhEMmJhZz09",
      ],
      [
        "COVID-19: 3pm-4pm",
        "https://zoom.us/j/91269804476?pwd=TmtqdVAxNWVjRFBEVzRDZ0xkNGEyZz09",
      ],
    ],
    sat_09_26_20: [
      [
        "Election Night: 9am-10am",
        "https://zoom.us/j/93605478094?pwd=VWxqN0grRHRLYThlbHZFR0RWRVpNdz09",
      ],
      [
        "Best Practices: 11am-12pm",
        "https://zoom.us/j/92700646856?pwd=WnFuSEZITG9tWUZqWSs3TFJPUnZhUT09",
      ],
      [
        "Voter Intimidation: 1pm-2pm",
        "https://zoom.us/j/93771578844?pwd=OEJja3pNTW1XNHMva0JFZjdBZnVUdz09",
      ],
      [
        "Equipment Troubleshooting: 3pm-4pm",
        "https://zoom.us/j/99938842869?pwd=RkhnUlRMazlkMWQxdkFyQlA1ZHNrQT09",
      ],
    ],
    m_09_28_20: [
      [
        "Closing Routine: 9am-10am",
        "https://zoom.us/j/98144470713?pwd=dWpZeU5oN01DS1lCOTk2MDRJZUtrQT09",
      ],
      [
        "Election Night: 11am-12pm",
        "https://zoom.us/j/92264529237?pwd=VTd0bFRyaEorQ0M0QnErZUw5UzVNdz09",
      ],
      [
        "Best Practices: 1pm-2pm",
        "https://zoom.us/j/93056070239?pwd=S2F1VlZhSzBLY056OFR1d0F6SEg3UT09",
      ],
      [
        "Voter Intimidation: 3pm-4pm",
        "https://zoom.us/j/93518143850?pwd=QmZBMWRmWFA1T21WOFRlUTBGY01Idz09",
      ],
    ],
    tu_09_29_20: [
      [
        "Voter Assistance: 9am-10am",
        "https://zoom.us/j/94213859166?pwd=SFhjRi9Jd0UxOS9rTEFuTTNoQ3B4UT09",
      ],
      [
        "Opening Routine: 11am-12pm",
        "https://zoom.us/j/95785058458?pwd=OUpadGs5VXpnQWo5NkFsd2gwd2s5UT09",
      ],
      [
        "Closing Routine: 1pm-2pm",
        "https://zoom.us/j/91794805067?pwd=bmMrdzFabExQaHdabVhxVDFNSU13UT09",
      ],
      [
        "Election Night: 3pm-4pm",
        "https://zoom.us/j/96066758950?pwd=M1lKTlM5VUovVmRqVGxKbm5sRDFyQT09",
      ],
    ],
    w_09_30_20: [
      [
        "Conditional Voter Registration and Provisional Ballots: 9am-10am",
        "https://zoom.us/j/98001159134?pwd=VFBaN0t1amJFZDJwTDNPSjVhdGJEUT09",
      ],
      [
        "Voter Assistance: 11am-12pm",
        "https://zoom.us/j/93669147733?pwd=d04wckdlMVFZaTAxK1FMT0lubmcwUT09",
      ],
      [
        "Opening Routine: 1pm-2pm",
        "https://zoom.us/j/97560269979?pwd=NjVVU0RZR1NpclRvWXVLYW9Zd3Y2UT09",
      ],
      [
        "Closing Routine: 3pm-4pm",
        "https://zoom.us/j/93962211801?pwd=U1ZHUnNUWm5lSGZibVA3Mm9VWFhhUT09",
      ],
    ],
    th_10_01_20: [
      [
        "Processing Voters: 9am-10am",
        "https://zoom.us/j/97452507666?pwd=VWk4bDZ0MldyKy91emFSSFNGYnlhZz09",
      ],
      [
        "Conditional Voter Registration and Provisional Ballots: 11am-12pm",
        "https://zoom.us/j/95919618250?pwd=YUlZc05oL3Jva2t4bUY0OWx3QVlSQT09",
      ],
      [
        "Voter Assistance: 1pm-2pm",
        "https://zoom.us/j/95241828698?pwd=ei9yQVA0M0NvMHpLalhPNmw5REpjdz09",
      ],
      [
        "Opening Routine: 3pm-4pm",
        "https://zoom.us/j/91771691828?pwd=SUxlQTAyWGpLMzZRWVdoSGlZdnJEQT09",
      ],
    ],
    f_10_02_20: [
      [
        "Forms: 9am-10am",
        "https://zoom.us/j/93717182975?pwd=MnVVTFJyMXMzbEFwY0FTWGhrUFZ3UT09",
      ],
      [
        "Processing Voters: 11am-12pm",
        "https://zoom.us/j/92439516192?pwd=WDZiWGRkdWlSY3lnRTA4dlRjWVIwZz09",
      ],
      [
        "Conditional Voter Registration and Provisional Ballots: 1pm-2pm",
        "https://zoom.us/j/91280786895?pwd=K2FKRUsrdWYyajI5eGhhQ2s2dDUrQT09",
      ],
      [
        "Voter Assistance: 3pm-4pm",
        "https://zoom.us/j/94101220939?pwd=MVJwalpMVHBzTUpoZnNCMjVydlhZdz09",
      ],
    ],
    sat_10_03_20: [
      [
        "COVID-19: 9am-10am",
        "https://zoom.us/j/97361959575?pwd=NzFXZGhLYjRmei9IcDVjbXBjMzR0dz09",
      ],
      [
        "Forms: 11am-12pm",
        "https://zoom.us/j/97995773755?pwd=bFNTYW40amRVM1JpRXJjcFlTQ2xRZz09",
      ],
      [
        "Processing Voters: 1pm-2pm",
        "https://zoom.us/j/91481210283?pwd=b1ZLQ01EblQwOFIramo5Q3lVdFd3dz09",
      ],
      [
        "Conditional Voter Registration and Provisional Ballots: 3pm-4pm",
        "https://zoom.us/j/99988526697?pwd=V2NoN1ZPMU9TVTdNMi9ZMm96WTQyUT09",
      ],
    ],
    m_10_05_20: [
      [
        "Equipment Troubleshooting: 9am-10am",
        "https://zoom.us/j/91325680205?pwd=N0NLdVRjS3M2Q3liTTlUS29ncXkwdz09",
      ],
      [
        "COVID-19: 11am-12pm",
        "https://zoom.us/j/99774967668?pwd=VUZTSHNsL0UyMlYvUDBRNitxeURuUT09",
      ],
      [
        "Forms: 1pm-2pm",
        "https://zoom.us/j/92017910204?pwd=R2pBSEFRMWErYlZxZjNLNXNIa2IrUT09",
      ],
      [
        "Processing Voters: 3pm-4pm",
        "https://zoom.us/j/93654045038?pwd=WFpBMitpdnF6ckNVeVpxNnoyY0Q4UT09",
      ],
    ],
    tu_10_06_20: [
      [
        "Best Practices: 9am-10am",
        "https://zoom.us/j/95439761296?pwd=OGhJZkZ4K2Zrb2QxYVY5U0FQYllndz09",
      ],
      [
        "Voter Intimidation: 11am-12pm",
        "https://zoom.us/j/95029791685?pwd=azh5bEFwTmJlbEJRVHF0S2NlZ3BrUT09",
      ],
      [
        "Equipment Troubleshooting: 1pm-2pm",
        "https://zoom.us/j/98220975327?pwd=TGxUTkhyWUZFWm9QYmRJSU9odnpKQT09",
      ],
      [
        "COVID-19: 3pm-4pm",
        "https://zoom.us/j/99221110762?pwd=a1J2ak1mb3QxVFlST09ITndJMStWZz09",
      ],
    ],
    w_10_07_20: [
      [
        "Election Night: 9am-10am",
        "https://zoom.us/j/96015697448?pwd=VkNSVTVtemFFOFgxc1J5ZllzN09jZz09",
      ],
      [
        "Best Practices: 11am-12pm",
        "https://zoom.us/j/99343496510?pwd=aVNiN0tkZGhNam04Y0ZoTTZIVW1EUT09",
      ],
      [
        "Voter Intimidation: 1pm-2pm",
        "https://zoom.us/j/91408229144?pwd=bDB3bkdwdW41Mm5nc25hZWtVVGdJUT09",
      ],
      [
        "Equipment Troubleshooting: 3pm-4pm",
        "https://zoom.us/j/94948417228?pwd=blVCbmFyYkRPd3g2ZWZwVE0yamV6Zz09",
      ],
    ],
    th_10_08_20: [
      [
        "Closing Routine: 9am-10am",
        "https://zoom.us/j/95258292286?pwd=aHVTTkE5Yzg5QXY0K1NMNVQybEprdz09",
      ],
      [
        "Election Night: 11am-12pm",
        "https://zoom.us/j/94584028320?pwd=UkREWDRsZnZBais1MmNSMzVPdlIvdz09",
      ],
      [
        "Best Practices: 1pm-2pm",
        "https://zoom.us/j/94204707493?pwd=cTlONXl2WlVwN01kaUpBUTI0aHd0UT09",
      ],
      [
        "Voter Intimidation: 3pm-4pm",
        "https://zoom.us/j/95584653024?pwd=LzQxcjlybVBXcEwwL2RrK1kyRDRLZz09",
      ],
    ],
    f_10_09_20: [
      [
        "Opening Routine: 9am-10am",
        "https://zoom.us/j/94771302909?pwd=L1ViNUNUMHVNZnVRNnpldEFUdWxxdz09",
      ],
      [
        "Closing Routine: 11am-12pm",
        "https://zoom.us/j/98752745138?pwd=N1ZFNW1KNFVRK1VoR2JrS2hqWXF5dz09",
      ],
      [
        "Election Night: 1pm-2pm",
        "https://zoom.us/j/92631242819?pwd=b1NiM3A1M0RVc1h5QTMvM3B6RGFLZz09",
      ],
      [
        "Best Practices: 3pm-4pm",
        "https://zoom.us/j/99516447215?pwd=NVpBVk9WWG1nS215Z2U4c3dJNVdIQT09",
      ],
    ],
    sat_10_10_20: [
      [
        "Voter Assistance: 9am-10am",
        "https://zoom.us/j/98517138595?pwd=TVQwQm1ZMm82NEJZdXRlc1A5NWhpQT09",
      ],
      [
        "Opening Routine: 11am-12pm",
        "https://zoom.us/j/92988185786?pwd=QVp3SjZ4L1h3WGJMZ3doRUpNbW91Zz09",
      ],
      [
        "Closing Routine: 1pm-2pm",
        "https://zoom.us/j/95196760262?pwd=ekxPOTFaWDlnZ3lJbDFxeWFCK2prQT09",
      ],
      [
        "Election Night: 3pm-4pm",
        "https://zoom.us/j/92667500380?pwd=S2VDcnpjQmJ6MGxKNldLNjZGbDU2QT09",
      ],
    ],
    m_10_12_20: [
      [
        "Conditional Voter Registration and Provisional Ballots: 9am-10am",
        "https://zoom.us/j/91347013720?pwd=YnI2eXJTTDF0VDNzUzVlWXk4UllhQT09",
      ],
      [
        "Voter Assistance: 11am-12pm",
        "https://zoom.us/j/95636621094?pwd=SkhxYXJzS1lmOVdZZWRtLzdwRE5Rdz09",
      ],
      [
        "Opening Routine: 1pm-2pm",
        "https://zoom.us/j/98407327679?pwd=RGNIVFh4TTZyUW9HTlFiaEdncktpQT09",
      ],
      [
        "Closing Routine: 3pm-4pm",
        "https://zoom.us/j/95746918081?pwd=WXgrZ1RkOVlhaWhUci83R1h0UER1QT09",
      ],
    ],
    tu_10_13_20: [
      [
        "Forms: 9am-10am",
        "https://zoom.us/j/98610570860?pwd=RnFqM0N3L3Uvb0NWQzI2U2pqT0FMQT09",
      ],
      [
        "Processing Voters: 11am-12pm",
        "https://zoom.us/j/93736679324?pwd=bnBXVzhZNStCWS9XeWJ4eG1rR09GUT09",
      ],
      [
        "Conditional Voter Registration and Provisional Ballots: 1pm-2pm",
        "https://zoom.us/j/97666456693?pwd=RHZLUHMwQ3lPRFl1R2x2ODJvVUZqQT09",
      ],
      [
        "Voter Assistance: 3pm-4pm",
        "https://zoom.us/j/95494952824?pwd=c0V1NkhTWS9IZmswVWdvTmdyOUFoQT09",
      ],
    ],
    w_10_14_20: [
      [
        "COVID-19: 9am-10am",
        "https://zoom.us/j/94776691453?pwd=Wm9xWkIxVUNjOW5ycG1KZXcyQ2Vvdz09",
      ],
      [
        "Forms: 11am-12pm",
        "https://zoom.us/j/95021379979?pwd=Z1JOQk12ZGUzeEF3MDVRMURlQ3dXUT09",
      ],
      [
        "Processing Voters: 1pm-2pm",
        "https://zoom.us/j/97783042691?pwd=bUNrYkdVK1JyUmNWVkJURVVsY0Y3dz09",
      ],
      [
        "Conditional Voter Registration and Provisional Ballots: 3pm-4pm",
        "https://zoom.us/j/91961407681?pwd=U1M4bGNWZTZIa3V2bHNRRnlDSHk0QT09",
      ],
    ],
    th_10_15_20: [
      [
        "Equipment Troubleshooting: 9am-10am",
        "https://zoom.us/j/98724001130?pwd=WXFlN2hBWGpNQjZOWGVsc3FBdW4vdz09",
      ],
      [
        "COVID-19: 11am-12pm",
        "https://zoom.us/j/94907378067?pwd=OFh5SnhyM1VRakpDclNQTS9DUmd1QT09",
      ],
      [
        "Forms: 1pm-2pm",
        "https://zoom.us/j/96140908916?pwd=VWMvaHRsOGpiZE00WGI4YS9QNG5NZz09",
      ],
      [
        "Processing Voters: 3pm-4pm",
        "https://zoom.us/j/97070636553?pwd=OGUwYXM1YnVyNmt2eWF0b0xMWFpGUT09",
      ],
    ],
    f_10_16_20: [
      [
        "Voter Intimidation: 9am-10am",
        "https://zoom.us/j/92966396402?pwd=MENoOERMTkV3cEozT20wcVZJMTRWQT09",
      ],
      [
        "Equipment Troubleshooting: 11am-12pm",
        "https://zoom.us/j/97939468934?pwd=K1NrZ0xSV3JZMU9iNXlUTTVvNW9yUT09",
      ],
      [
        "COVID-19: 1pm-2pm",
        "https://zoom.us/j/92529073762?pwd=OGdkcGZFRXM3S3JYS0hnQWg4N3lIZz09",
      ],
      [
        "Forms: 3pm-4pm",
        "https://zoom.us/j/99860937963?pwd=blZvRWpaeUF3M3gybmljOGw1SWZRUT09",
      ],
    ],
    sat_10_17_20: [
      [
        "Best Practices: 9am-10am",
        "https://zoom.us/j/91997128078?pwd=QzgzZ1VZVklVQU54UEVqTnB2Vm4yQT09",
      ],
      [
        "Voter Intimidation: 11am-12pm",
        "https://zoom.us/j/96440721792?pwd=OUExNk9FeXdFVU0wenJpOGZoeEVYdz09",
      ],
      [
        "Equipment Troubleshooting: 1pm-2pm",
        "https://zoom.us/j/98690096948?pwd=NUhYbi9HaHBER2Z2Ui85WGk5aTRNUT09",
      ],
      [
        "COVID-19: 3pm-4pm",
        "https://zoom.us/j/96315873066?pwd=NTZxUGFDdDlxajJMOFpJaXdpeXNuZz09",
      ],
    ],
    m_10_19_20: [
      [
        "Election Night: 9am-10am",
        "https://zoom.us/j/98396871971?pwd=cEhRanA5YjB1aVJEUkFVQm1ma1poUT09",
      ],
      [
        "Best Practices: 11am-12pm",
        "https://zoom.us/j/98104627804?pwd=R29OSjlTdUt0a3pLaG5Zc1BFNTJIUT09",
      ],
      [
        "Voter Intimidation: 1pm-2pm",
        "https://zoom.us/j/97263952258?pwd=VHl1SUU1aDMyOWxyTHZiRm82WU9zUT09",
      ],
      [
        "Equipment Troubleshooting: 3pm-4pm",
        "https://zoom.us/j/98294211206?pwd=S25GVkFPV3pGNVp2cGMxK3p2ZHdVUT09",
      ],
    ],
    tu_10_20_20: [
      [
        "Opening Routine: 9am-10am",
        "https://zoom.us/j/91853571178?pwd=THUxanhUQUcvRmdEZndWajA0TmFzdz09",
      ],
      [
        "Closing Routine: 11am-12pm",
        "https://zoom.us/j/94580910305?pwd=T3FKYStHdHgrN2F4RnBtTTV6djNPUT09",
      ],
      [
        "Election Night: 1pm-2pm",
        "https://zoom.us/j/92590176478?pwd=UW1uM1ZsZjRMZG9Yb0xSNWJVTEFRdz09",
      ],
      [
        "Best Practices: 3pm-4pm",
        "https://zoom.us/j/91007308147?pwd=VVVrWDNTQlNrZGdBdTNzNWQyd3BYdz09",
      ],
    ],
    w_10_21_20: [
      [
        "Voter Assistance: 9am-10am",
        "https://zoom.us/j/96001719033?pwd=cFhWdk5HbDdHYjNWZy9FNDUrbS9vZz09",
      ],
      [
        "Opening Routine: 11am-12pm",
        "https://zoom.us/j/92196022370?pwd=ZG5QTnFZTkJZQzN2S2lzTmI2ZTBOZz09",
      ],
      [
        "Closing Routine: 1pm-2pm",
        "https://zoom.us/j/99568156037?pwd=SEpoNzNRdmQ1cFZtZWs1WU5vbi9DUT09",
      ],
      [
        "Election Night: 3pm-4pm",
        "https://zoom.us/j/92525388349?pwd=MjNOUVRqNG52VzVGQ251Z2FvMWpBZz09",
      ],
    ],
    th_10_22_20: [
      [
        "Conditional Voter Registration and Provisional Ballots: 9am-10am",
        "https://zoom.us/j/94966029129?pwd=cVR5MkRwZ0pEeTVDSmdKWE9aeDN2QT09",
      ],
      [
        "Voter Assistance: 11am-12pm",
        "https://zoom.us/j/99371331264?pwd=QU94QkhWK3ovSXlRMHhUaG0veGNoZz09",
      ],
      [
        "Opening Routine: 1pm-2pm",
        "https://zoom.us/j/98453466515?pwd=bytFcFFnMS9McWM0Y29mQjV4cE5EZz09",
      ],
      [
        "Closing Routine: 3pm-4pm",
        "https://zoom.us/j/95778580085?pwd=YWg1am93QW84ZkJ3NTlKbGt2b3p1Zz09",
      ],
    ],
    f_10_23_20: [
      [
        "Processing Voters: 9am-10am",
        "https://zoom.us/j/93258894530?pwd=Y0s1aW92VEFpOE9qQ3AvcFQvUDJ6QT09",
      ],
      [
        "Conditional Voter Registration and Provisional Ballots: 11am-12pm",
        "https://zoom.us/j/94408850951?pwd=OVRmS0IyR29CS29nU014MlNKcnlSZz09",
      ],
      [
        "Voter Assistance: 1pm-2pm",
        "https://zoom.us/j/96222592618?pwd=TjUvTnJHTEk2b2pNY3ZNMkNGS0FWdz09",
      ],
      [
        "Opening Routine: 3pm-4pm",
        "https://zoom.us/j/94545412532?pwd=a21YOUVWTVlUWmFpdkg0aGMxSUJEQT09",
      ],
    ],
    tu_10_27_20: [
      [
        "Conditional Voter Registration and Provisional Ballots: 12pm-1pm",
        "https://zoom.us/j/97982687598",
      ],
      ["Voter Intimidation: 2pm-3pm", "https://zoom.us/j/95425229139"],
    ],
  };

  getClassesByRange(days) {
    // get current date
    const date = new Date();
    const nextDays = new Date();
    // set future date to get all zoom meetings
    date.setDate(date.getDate() - 1);
    nextDays.setDate(date.getDate() + days + 1);
    // // convert dates to state format
    // const startDate = `${
    //   date.getMonth() + 1
    // }_${date.getDate()}_${date.getFullYear().toString().substring(2)}`;
    // const endDate = `${
    //   nextDays.getMonth() + 1
    // }_${nextDays.getDate()}_${nextDays.getFullYear().toString().substring(2)}`;

    const keys = Object.keys(this.state);
    const meetings = keys
      .filter((key) => {
        const keyDate = new Date(key.split("_").slice(1).join("-"));
        if (keyDate >= date && keyDate <= nextDays) return true;
        return false;
      })
      .map((item) => item);
    return (
      <ul>
        {meetings.map((date, i) => {
          const formattedDate = date.split("_").slice(1).join("-");
          return (
            <li key={i}>
              <strong>{formattedDate}</strong>
              <ul>
                {this.state[date].map((mtg, i) => {
                  return (
                    <li key={i}>
                      <a
                        href={this.state[date][i][1]}
                        alt="Zoom Meeting"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {this.state[date][i][0]}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>
    );
  }

  render() {
    return (
      <Container>
        <h3 className="mt-3 mb-3">Deep Dives</h3>
        <p>
          Deep Dive Sessions are now available for this election. Please see below for more information.
        </p>
		<p>
		<a href="/pdfs/Calendar_for_Zoom_QA_Sessions.pdf" target="_blank"> Calendar for Deep Dive Q&As</a>
		</p>
		<p>
		Deep Dive videos:
		</p>
		<iframe width="560" height="315" src="https://www.youtube.com/embed/fZKOuYrXjFA" title="YouTube" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		<p>
		</p>
		<iframe width="560" height="315" src="https://www.youtube.com/embed/Lv-UjcgIASM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		<p>
		</p>
		<iframe width="560" height="315" src="https://www.youtube.com/embed/xn2aNtzhRPo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		
		
		{this.getClassesByRange(7)}
      </Container>
    );
  }
}

export default ZoomInfo;
